<template>
    <div> <!-- Element rădăcină -->
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('gestiune.casaRegister')"></general-top-bar> -->

      <div class="action-buttons">
        <div class="left-buttons">
         </div>
         <div class="right-buttons">
            <button class="btn add mar-rt-10"  @click.prevent="addCasaRegister" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{$t('general.add')}}
            </button>
            <el-button type="success" @click="downloadCasaRegister">
                {{ $t('gestiune.downloadInventory') }}
            </el-button>
         </div>
      </div>
      <!--End General Top Bar -->
      <div class="card mar-to-15">
          <div class="card-content">
            <div class="data-table">
                <el-table :data="tableData">
                    <el-table-column prop="date" :label="$t('gestiune.date')"></el-table-column>
                    <el-table-column prop="action" :label="$t('gestiune.action')"></el-table-column>
                    <el-table-column prop="document" :label="$t('gestiune.document')"></el-table-column>
                    <el-table-column prop="details" :label="$t('gestiune.details')"></el-table-column>
                    <el-table-column prop="payments" :label="$t('gestiune.payments')"></el-table-column>
                    <el-table-column prop="collections" :label="$t('gestiune.collections')"></el-table-column>
                    <el-table-column prop="balance" :label="$t('gestiune.balance')"></el-table-column>
                </el-table>
            </div>
           </div>
      </div>
      <vmodal name="casaRegisterModal" height="auto" width="800" class="casaRegisterModal">
        <div class="card">
            <div class="card-content">
            <div class="modal-header">
                <p>{{ $t('gestiune.addCasaRegister') }}</p>
            </div>
            <div class="modal-body">
                <div class="row">
                <div class="col-md-6">
                    <div class="form-group" style="display: grid;">
                    <label for="data">{{ $t('gestiune.data') }}</label>
                    <el-date-picker
                        v-model="form.date"
                        type="date"
                        placeholder="Selectează data"
                    />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" style="display: grid;">
                    <label for="document">{{ $t('gestiune.document') }}</label>
                    <el-input
                        v-model="form.document"
                        placeholder="Introduceți documentul"
                    />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" style="display: grid;">
                    <label for="reason">{{ $t('gestiune.motiv') }}</label>
                    <el-input
                        v-model="form.reason"
                        placeholder="Introduceți motivul"
                    />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" style="display: grid;">
                    <label for="value">{{ $t('gestiune.value') }}</label>
                    <el-input
                        v-model="form.value"
                        placeholder="Introduceți valoarea"
                    />
                    </div>
                </div>
                </div>
            </div>
            <div class="modal-footer">
              <div class="button-group">
                <button class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
                <a class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
              </div>
            </div>
          </div>
        </div>
      </vmodal>
    </div>
</template>

  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    export default {
      components: {
        // GeneralTopBar
      },
      data () {
        return {
          tableData: [
            {
              date: '2024-11-01',
              action: 'Updated',
              document: 'Doc123',
              details: 'Updated the record details',
              payments: '200',
              collections: '150',
              balance: '50'
            }
          ],
          form: {
            date: '',
            document: '',
            reason: '',
            value: ''
          }
        }
      },
      methods: {
        addCasaRegister () {
          this.$modal.show('casaRegisterModal')
        }
      }
    }
  </script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.el-date-editor {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Casa/ManagementCasaRegister.vue